import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-triangle-icon',
  templateUrl: './design-triangle.component.html'
})
export class DesignTriangleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
